/** Catch-all route: an unknown path inside the authenticated area. */

import { Link } from 'react-router';
import { EmptyState } from '../components';
import { useDocumentTitle } from '../lib/hooks';
import { APP_NAME, pageTitle } from './appTitle';
import { HOME_PATH } from './routes';

export function NotFoundPage() {
  useDocumentTitle(pageTitle('Page not found'));

  return (
    <div className="center-fill">
      <EmptyState
        title="Page not found"
        description={`That URL doesn't match any screen in ${APP_NAME}.`}
        action={
          <Link className="btn-primary" to={HOME_PATH}>
            Back to profiles
          </Link>
        }
      />
    </div>
  );
}

export default NotFoundPage;
